import { useContext } from "react";
import Sidebar from "./Sidebar";
import Breadcrumbs from "./Breadcrumbs";
import Header from "./Header";
import AlertSnackbar from "./AlertSnackbar";
import ChatWidget from "./chat/ChatWidget";
import { ChatContext } from "../contexts/ChatContext";
import { SidebarProvider } from "../contexts/SidebarContext";

// Material-UI imports
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";

export const PageLayout = (props) => {
  const { isPinned, isOpen } = useContext(ChatContext);
  const chatPinned = isPinned && isOpen;

  return (
    <SidebarProvider>
      <CssBaseline />
      <Box sx={{ display: "flex", minHeight: "100dvh" }}>
        <Header />
        <Sidebar />
        <AlertSnackbar />
        <ChatWidget />
        <Box
          sx={{
            bgcolor: "background.default",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
            height: "100dvh",
            overflow: "hidden auto",
            marginRight: chatPinned ? "400px" : 0,
            transition: "margin-right 225ms cubic-bezier(0, 0, 0.2, 1)",
          }}
        >
          <Toolbar />
          <Breadcrumbs />
          <Box
            component="main"
            className="MainContent"
            sx={{
              px: {
                xs: 1,
                md: 6,
              },
              pt: 3,
              pb: 10,
              flex: 1,
              display: "flex",
              flexDirection: "column",
              minWidth: 0,
              gap: 1,
            }}
          >
            {props.children}
          </Box>
        </Box>
      </Box>
    </SidebarProvider>
  );
};
